import { OrganizationInfoResponse, PayoutFee } from '@/types/organization'

import { branchHttp } from './branch-http'
import { http } from './http'

/**
 * Retrieves organization information.
 * uses seperate axios instance since endpoint is not protected by auth
 * @param uuid organization uuid
 */
export const getOrgInfo = (uuid: string) =>
  branchHttp.get<OrganizationInfoResponse>(`/p1/organizations?uuid=${uuid}`)

/**
 * Retrieves organization payout fee.
 */

export const getPayoutFees = (uuid: string) =>
  http.get<PayoutFee[]>(`/payout/v2/public/organization/fees?uuid=${uuid}`)
